import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';

export const ownerAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '19794', image: bildJa },
    { name: 'Nein', available: false, value: 'nein', api: '19795',  image: bildNein },
];

export const ownerApi = {parameter: '17066', type: 'value_choice'};